import useSyncCalendar from '@/queries/sync-calendar.queries';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IArgs {
	isOpen: boolean;
	close: () => void;
}

export function useAddCalendarController(args: IArgs) {
	const { handleSyncGoogle, handleSyncMicrosoft } = useSyncCalendar();
	const { t } = useTranslation();
	const toast = useToast();

	function handleSyncGoogleClick() {
		handleSyncGoogle()
			.then(() => {
				toast({ isClosable: true, title: t('Google calendar synced'), status: 'success' });
				args.close();
			})
			.catch(() => {
				toast({ isClosable: true, title: t('Error syncing Google calendar'), status: 'error' });
			});
	}

	return {
		t,
		handleSyncGoogleClick,
		handleSyncMicrosoft,
	};
}
